export default "__VITE_ASSET__e76ce884__"